import { useEffect, useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import CopyToClipboard from 'react-copy-to-clipboard';
import SyntaxHighlighter from 'react-syntax-highlighter';
import theme from 'react-syntax-highlighter/dist/esm/styles/hljs/shades-of-purple';
import Svg from '../atoms/Svg';

const CodeViewer = ({ code, title, visible = false }) => {
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        if (!copied) {
            return;
        }

        setTimeout(() => {
            setCopied(false);
        }, 1500);
    }, [copied]);

    return (
        <div className='card text-white bg-code shadow-sm mt-5'>
            <div
                className='card-header collapsible collapsed cursor-pointer rotate'
                data-bs-toggle='collapse'
                data-bs-target={`#card_collapsible_code`}>
                <h3 className='card-title text-white'>{title}</h3>
                <div className='card-toolbar'>
                    <OverlayTrigger
                        placement='top'
                        overlay={<Tooltip id='tooltip-user-name'>Copy to Clipboard</Tooltip>}>
                        <CopyToClipboard
                            text={JSON.stringify(code, null, 4)}
                            onCopy={() => setCopied(true)}>
                            <span className='svg-icon svg-icon-1 me-2 text-warning'>
                                <Svg
                                    icon='copy'
                                    className='svg-icon-2 text-warning'
                                />
                                &nbsp;{copied ? 'copied' : 'Copy'}
                            </span>
                        </CopyToClipboard>
                    </OverlayTrigger>
                    <span className='svg-icon svg-icon-1'>
                        <Svg
                            icon='down'
                            className='svg-icon-2'
                        />
                    </span>
                </div>
            </div>
            <div
                id={`card_collapsible_code`}
                className={`collapse ${visible ? 'show' : 'hide'}`}>
                <div className='card-body p-0'>
                    <SyntaxHighlighter
                        language='json'
                        style={theme}
                        showLineNumbers={true}
                        wrapLines={true}
                        wrapLongLines={true}
                        className='m-0'>
                        {JSON.stringify(code, null, 4)}
                    </SyntaxHighlighter>
                </div>
            </div>
        </div>
    );
};

export default CodeViewer;
